import { useSelector } from "../../../../../redux/store";
import { IContract } from "../../../../../models/Contract";
import {
  getAccessibilityUnitsCounts,
  getContractData, getCountsDisabilityTypes,
  getTotalAccessibilityProgressBar,
  getUnitImagesCount
} from "../../../../../selectors";
import { Grid } from "@material-ui/core";
import SubscriptionExpiring from "../widgets/SubscriptionExpiring";
import NumberOfPhotosUploaded from "../widgets/NumberOfPhotosUploaded";
import React, { FC } from "react";
import TotalAmountOfProperties from "../widgets/TotalAmountOfProperties";
import NumberOfUnits from "../widgets/NumberOfUnits";
import TotalAccessibilityDataPoints from "../widgets/TotalAccessibilityDataPoints";
import YourSubscription from "../widgets/YourSubscription";

type PropsType = {
  selectedCompanyId: string
}

const BusinessMetrics: FC<PropsType> = ({selectedCompanyId}) => {
  const contractData = useSelector<IContract | any>(getContractData)
  const countImages = useSelector(getUnitImagesCount)
  const totalAmountProperties = useSelector(getTotalAccessibilityProgressBar)
  const countsAccessibility = useSelector<any>(getAccessibilityUnitsCounts)
  const countDisabilityTypes = useSelector<any>(getCountsDisabilityTypes)

  return (
    <>
      <Grid item xs={12} sm={6} md={3}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <SubscriptionExpiring contractData={contractData} />
          </Grid>
          <Grid item xs={12}>
            <NumberOfPhotosUploaded
              count={countImages}
              selectedCompanyId={selectedCompanyId}
            />
          </Grid>
          <Grid item xs={12}>
            <YourSubscription contractData={contractData} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={6}>
            <TotalAmountOfProperties data={totalAmountProperties} />
          </Grid>
          <Grid item xs={12} md={6}>
            <NumberOfUnits data={countsAccessibility} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={3}>
        <Grid item xs>
          <TotalAccessibilityDataPoints data={countDisabilityTypes} />
        </Grid>
      </Grid>
      </>
  )
}
export default BusinessMetrics
